import styled from "styled-components";

export const ColumnTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const TitleWrapper = styled.span``;